import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-item-report',
  templateUrl: './sub-item-report.component.html',
  styleUrls: ['./sub-item-report.component.css']
})
export class SubItemReportComponent implements OnInit {

  public menu_item_id = '27';
  private dp = [];
  unit_list = [];
  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  displayedColumns = ['sub_item_number', 'main_item_name', 'sub_item_no', 'unit_name',
    'item_subcat_name', 'item_cat_name'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'main_item_name': '', 'sub_item_no': '', 'title': 'تقرير الأصناف',
    'item_cat_id': '', 'item_subcat_id': '', 'unit_id': ''
  };

  Items_Report; Main_Cat_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Items_Report').subscribe((res: string) => {
      this.Items_Report = res;
    });
    this.model['title'] = this.Items_Report;

    translate.get('Main_Cat_Msg').subscribe((res: string) => {
      this.Main_Cat_Msg = res;
    });
  }

  ngOnInit() {
    let query, obj;
    query = this.queryList.all_itemCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.itemCats = data.data['list'];
      });

    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_itemSubCats = data.data['list'];
      });

    query = this.queryList.all_unit;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.unit_list = data.data['list'];
      });
  }

  getSubCat() {
    this.itemSubCats = [];
    this.all_itemSubCats.forEach(element => {
      if (element.item_cat_id == this.model['item_cat_id'])
        this.itemSubCats.push(element);
    });
    if (this.itemSubCats.length > 0)
      this.model['item_subcat_id'] = this.itemSubCats[0]['item_subcat_id'];
  }

  search() {

    if (this.model['item_cat_id'] == '') {
      alert(this.Main_Cat_Msg);
      return;
    }

    let obj = { cmd: 'getSubItemRep' }; 

    if (this.model['main_item_name'] != '')
      obj['main_item_name'] = this.model['main_item_name'];
      
    if (this.model['sub_item_no'] != '')
      obj['sub_item_no'] = this.model['sub_item_no'];

    if (this.model['item_cat_id'] != '')
      obj['item_cat_id'] = this.model['item_cat_id'];

    if (this.model['item_subcat_id'] != '')
      obj['item_subcat_id'] = this.model['item_subcat_id'];

    if (this.model['unit_id'] != '')
      obj['unit_id'] = this.model['unit_id'];
     
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2> ' + this.Items_Report + '</h2></td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
